import { AbstractIcon } from "./abstract";
import { componentsRegistryService } from "cruzo";

/** IBM Carbon Design System — string-text icon (32px artboard). */
export class CarbonStringTextIcon extends AbstractIcon {
  static selector = "carbon-string-text-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M29 22H24a2.0027 2.0027 0 01-2-2V14a2.0023 2.0023 0 012-2h5v2H24v6h5zM18 12H14V8H12V22h6a2.0027 2.0027 0 002-2V14A2.0023 2.0023 0 0018 12zm-4 8V14h4v6zM8 12H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V14A2.0023 2.0023 0 008 12zm0 8H4V18H8z"/>
    </svg>`;
  }
}

componentsRegistryService.define(CarbonStringTextIcon);
